import module from 'module';

const templateUrl = require('./discount-predicate.template.html');
module.component('discountPredicate', {
  templateUrl,
  bindings: {
    predicates: '=',
    /**
     * One of:
     * - DISCOUNT_GREATER_THAN
     * - DISCOUNT_GREATER_THAN_OR_EQUAL
     * - DISCOUNT_LESS_THAN
     * - DISCOUNT_LESS_THAN_OR_EQUAL
     */
    type: '<'
  },
  controller: function ($scope) {
    const that = this;

    $scope.$watchCollection('$ctrl.predicates', () => {
      if (!that.predicates) {
        that.value = null;
      } else {
        that.value = that.predicates[that.type];
      }

    });

    that.valueChanged = () => {
      that.predicates[that.type] = that.value;
    };

  }
});
